<template>
  <span class="mt-2 error-explanation">{{ message }}</span>
</template>

<script>
export default {
  props: ['message']
};
</script>
